module.exports = __webpack_public_path__ + "i.no1.3c0e16d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/i.no1.jpg
// module id = mq2W
// module chunks = 0